export default __webpack_public_path__ + "static/media/Quote3.bfcfccf9.svg";